import { render, staticRenderFns } from "./Dashboard_2.vue?vue&type=template&id=a5662c0e&scoped=true&"
import script from "./Dashboard_2.vue?vue&type=script&lang=js&"
export * from "./Dashboard_2.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_2.vue?vue&type=style&index=0&id=a5662c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5662c0e",
  null
  
)

export default component.exports